// extracted by mini-css-extract-plugin
export default {"section-title":"SectionTitle_section-title__IJKv4"};